import { countryName } from "~/helpers/countries";
import { cn } from "~/lib/utils";

const FLAG_URLS = import.meta.glob<string>(
  "/node_modules/country-flag-icons/3x2/*.svg",
  { eager: true, query: "?no-inline", import: "default" }
);

interface CountryFlagProps {
  code: string;
  className?: string;
}

export default function CountryFlag({ code, className }: CountryFlagProps) {
  const src = FLAG_URLS[`/node_modules/country-flag-icons/3x2/${code}.svg`];
  const name = countryName(code);

  if (!src) {
    return (
      <span
        className={cn(
          "inline-flex h-3 items-center text-[9px] font-semibold text-muted-foreground",
          className
        )}
        title={name}
      >
        {code}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      loading="lazy"
      className={cn(
        "inline-block h-3 w-[18px] shrink-0 rounded-[2px] object-cover ring-1 ring-black/10",
        className
      )}
    />
  );
}
